module.exports = "<div class=\"ui active dimmer\">\r\n  <div class=\"ui huge inverted text loader\">Đang xử lý</div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/shared/callback/callback.component.html
// module id = ../../../../../src/app/shared/callback/callback.component.html
// module chunks = main